var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 4.497,
    fill: "rgb(255, 255, 255)",
    rx: 1,
    ry: 1,
    transform: "rotate(-30.00001 14.00021997 4.49706357)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.504,
    cy: 1.999,
    fill: "rgb(255, 255, 255)",
    rx: 1,
    ry: 1,
    transform: "rotate(-60.000021 11.50416512 1.99926341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255, 255, 255)",
    fillRule: "evenodd",
    d: "M6.5 4v3.5c0 1.1045695.8954305 2 2 2h3v-2h-3V4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255, 255, 255)",
    fillRule: "evenodd",
    d: "M14 8c0 3.3137085-2.6862915 6-6 6s-6-2.6862915-6-6 2.6862915-6 6-6h1V0H8C3.581722 0 0 3.581722 0 8s3.581722 8 8 8 8-3.581722 8-8V7h-2v1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingIcon);
export default __webpack_public_path__ + "static/media/waiting_icon.0483d8d2c7f6d5665bbb6de4a158b1ed.svg";
export { ForwardRef as ReactComponent };